import { MAX_TRIAGE_LABELS } from "../../Agents/goals/validation";

import { VocabularyBlock } from "./VocabularyBlock";

export interface DatasetTriageGoalFormProps {
  index: number;
}

/**
 * What a dataset-triage goal needs: the labels it may apply, and what each
 * one means. The label becomes a tag on the dataset; the description is what
 * the model reads when deciding whether it fits.
 */
export function DatasetTriageGoalForm({ index }: DatasetTriageGoalFormProps) {
  return (
    <VocabularyBlock
      name={`goals.${index}.label_vocabulary`}
      keyField="label"
      title="Label vocabulary"
      hint={
        <>
          Each label is a tag the agent may apply to the dataset. Reference a
          variable in a description with <code>{"{{name}}"}</code>.
        </>
      }
      keyHeading="Label"
      keyPlaceholder="anomalous"
      descriptionHeading="When it applies"
      descriptionPlaceholder="Worth a human look — unusual signal patterns."
      addLabel="Add label"
      max={MAX_TRIAGE_LABELS}
      testId={`agent-goal-${index}-labels`}
    />
  );
}
